import { render, staticRenderFns } from "./IntegrationsKeyForm.vue?vue&type=template&id=01167fa9"
import script from "./IntegrationsKeyForm.vue?vue&type=script&lang=js"
export * from "./IntegrationsKeyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports